module.exports = __webpack_public_path__ + "static/img/erweima_ceshi.a483b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima/erweima_ceshi.jpg
// module id = 3jpX
// module chunks = 124